import axios from 'axios'
import { ApiController } from './types'
import axiosPunchlist from '../punchlist/axios'

const apiController: ApiController = {
  uploadFile: async (signedURL: string, file: File) =>
    await axios
      .put(signedURL, file, {
        headers: {
          'Content-Type': file.type
        }
      })
      .then(response => response),
  downloadFile: async (documentType: string, resourceId: string, parameters: any) =>
    await axiosPunchlist.post(`/documents/pdf`, {
      documentType,
      resourceId,
      parameters
    })
      .then(response => response),
  getPDF: async (reportId: string) =>
    await axiosPunchlist.get(`/documents/pdf/${reportId}`)
      .then(response => response)
}

export default apiController
